import {Directive, ElementRef, HostListener} from '@angular/core';

@Directive({
    selector: '[appNumbersOnly]',
    standalone: false
})
export class NumbersOnlyDirective {
  constructor(private el: ElementRef) {}

  @HostListener('input', ['$event'])
  onInput(event: any): void {
    const input = event.target.value;
    const cleanInput = input.replace(/[^0-9.-]/g, '');

    this.el.nativeElement.value = Number(cleanInput).toLocaleString('en-US', {
      style: 'currency',
      currency: 'USD',
      maximumFractionDigits: 0
    });
  }
}
